// Original Adani-inspired brand mark (no third-party branding).
export function BrandMark({ size = 34, light = false }) {
  const primary = light ? "#FFFFFF" : "#0F2C59";
  const gold = "#D97706";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="2" y="2" width="44" height="44" rx="11" fill={light ? "rgba(255,255,255,0.10)" : "#0F2C59"} />
      <path d="M24 10L36 34H29.5L24 21.5L18.5 34H12L24 10Z" fill={light ? "#FFFFFF" : "#00A3E0"} />
      <path d="M24 24L29.5 34H18.5L24 24Z" fill={gold} />
      <rect x="2" y="2" width="44" height="44" rx="11" stroke={light ? "rgba(255,255,255,0.25)" : "#E2E8F0"} strokeWidth="1.5" />
    </svg>
  );
}

export function BrandWordmark({ light = false, compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-wordmark">
      <BrandMark light={light} />
      {!compact && (
        <div className="leading-tight">
          <div className={`font-heading font-extrabold text-[15px] tracking-tight ${light ? "text-white" : "text-[#0F2C59]"}`}>
            SchemeCentral
          </div>
          <div className={`text-[10px] font-medium tracking-wider uppercase ${light ? "text-cyan-200/80" : "text-slate-400"}`}>
            Incentive Platform
          </div>
        </div>
      )}
    </div>
  );
}
